import { render, staticRenderFns } from "./PhotoAndText.vue?vue&type=template&id=28bd53e9&scoped=true&"
import script from "./PhotoAndText.vue?vue&type=script&lang=js&"
export * from "./PhotoAndText.vue?vue&type=script&lang=js&"
import style0 from "./PhotoAndText.vue?vue&type=style&index=0&id=28bd53e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bd53e9",
  null
  
)

export default component.exports